module.exports = __webpack_public_path__ + "assets/img/script_javascript_import.f3a1a990.jpg";